import React from "react"

import Container from "@ecom/ui/components/Container"
import { StaticImage } from "gatsby-plugin-image"
import cn from "classnames"
import Cancel from "./img/Cancel"

import * as styles from "./comparisonTable.module.scss"

type Props = {
  orderNum?: string
}

export default function ComparisonDebetTable({ orderNum }: Props) {
  return (
    <section className={styles.section} data-exclude={orderNum}>
      <Container className={styles.container}>
        <div className={styles.secondContainer}>
          <StaticImage
            className={cn(styles.img, styles.creditCardImg)}
            alt="creditCard"
            src="./img/debet.png"
            placeholder="blurred"
            formats={["auto", "webp", "avif"]}
            layout="constrained"
          />
          <StaticImage
            className={cn(styles.img, styles.halvaImg)}
            alt="halva"
            src="./img/whiteHalvaCard.png"
            placeholder="blurred"
            formats={["auto", "webp", "avif"]}
            layout="constrained"
          />
          <table className={styles.table}>
            <thead>
              <tr>
                <td />
                <td className={styles.tableTitle}>
                  Дебетовая <br /> карта
                </td>
                <td className={styles.tableTitle}>
                  Карта <br /> рассрочки*
                </td>
              </tr>
            </thead>
            <tbody>
              <tr className={cn(styles.tableRow, styles.tableRow1)}>
                <td className={styles.tableSubtitle}>Кэшбэк</td>
                <td className={styles.tableText}>до 3000</td>
                <td className={styles.tableText}>до 5000</td>
              </tr>
              <tr className={cn(styles.tableRow, styles.tableRow2)}>
                <td className={styles.tableSubtitle}>Выгода</td>
                <td>
                  <Cancel />
                </td>
                <td className={styles.tableText}>До +5% годовых к&nbsp;ставке вклада</td>
              </tr>
              <tr className={cn(styles.tableRow, styles.tableRow3)}>
                <td className={styles.tableSubtitle}>Скидки от партнеров</td>
                <td>нет</td>
                <td className={styles.tableText}>да</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </section>
  )
}
